export interface ILoaiDuAn {
  id?: number;
  ten?: string | null;
}

export const defaultValue: Readonly<ILoaiDuAn> = {};
